module.exports = __webpack_public_path__ + "static/media/kelly-sikkema-4JxV3Gs42Ks_large.277f7c09.jpg";